// server metohd
const send = (client, data) => client.request({
  url: '/SmsAuth/Send',
  method: 'post',
  data,
});

const verify = (client, data) => client.request({
  url: '/SmsAuth/Verify',
  method: 'post',
  data,
});

export default {
  send,
  verify,
};
